import { z } from "zod";
import { moneySchema, timestampSchema, uuidSchema } from "../common/primitives.js";
import { evCommandStatusSchema, evPaymentMethodSchema, evPaymentStatusSchema, evSessionPhaseSchema, } from "./enums.js";
/**
 * Müşteri uygulaması (sürücü) — şarj başlatma (Prompt 19, ADR 0019 §13). Uygulamada ÖDEME YOKTUR: başlatma yalnızca FİLO
 * HAKKIYLA (müşterinin carisi etkin bir filo hesabı) ya da `EV` kapsayan etkin ABONELİKLE yapılır. Sunucu tek kullanımlık
 * idTag üretir (`APP`, müşteri / abonelik / filo bağlı) ve `RemoteStartTransaction` kuyruğa girer. Kiracı istekte açıkça
 * verilir; sürücünün o kiracıda etkin bağı olmalıdır. İdempotency: istemci `requestId` üretirse yinelenen istek aynı
 * sonucu döner (sürücü uçlarında kiracı bağlamı olmadığından başlıklı Idempotency-Key yerine bu alan kullanılır).
 */
export const driverEvStartSchema = z.object({
    tenantId: uuidSchema,
    stationId: uuidSchema,
    chargerId: uuidSchema,
    connectorNo: z.number().int().min(1).max(20),
    subscriptionId: uuidSchema
        .nullable()
        .default(null)
        .describe("Kullanılacak abonelik; boşsa önce filo hakkı, yoksa EV kapsayan ilk abonelik"),
    vehicleId: uuidSchema.nullable().default(null),
    requestId: uuidSchema.nullable().default(null).describe("İstemcinin ürettiği kimlik (yinelenen istek)"),
});
export const driverEvStartStatusSchema = z.object({
    tokenId: uuidSchema,
    stationId: uuidSchema,
    chargerId: uuidSchema,
    connectorNo: z.number().int(),
    entitlement: z.enum(["FLEET", "SUBSCRIPTION"]),
    subscriptionId: uuidSchema.nullable(),
    expiresAt: timestampSchema,
    /** Belirteç: ACTIVE (bekleniyor) → USED (oturum başladı) | EXPIRED | CANCELLED. */
    status: z.enum(["ACTIVE", "USED", "EXPIRED", "CANCELLED"]),
    commandId: uuidSchema.nullable(),
    commandStatus: evCommandStatusSchema.nullable(),
    sessionId: uuidSchema.nullable().describe("Ünite oturumu başlatınca dolar"),
});
export const driverEvTenantQuerySchema = z.object({ tenantId: uuidSchema });
export const driverEvSessionSchema = z.object({
    id: uuidSchema,
    stationId: uuidSchema,
    stationName: z.string(),
    chargerName: z.string().nullable(),
    connectorNo: z.number().int().nullable(),
    phase: evSessionPhaseSchema,
    startedAt: timestampSchema,
    chargingEndedAt: timestampSchema.nullable(),
    completedAt: timestampSchema.nullable(),
    energyKwh: z.string(),
    powerW: z.number().int().nullable(),
    socPercent: z.string().nullable(),
    chargingSeconds: z.number().int(),
    idleSeconds: z.number().int(),
    coveredKwh: z.string(),
    totalAmount: moneySchema,
    paymentStatus: evPaymentStatusSchema,
    paymentMethod: evPaymentMethodSchema.nullable(),
});
//# sourceMappingURL=driver.js.map